import { z } from 'zod';

export const GameItemSlotSchema = z.enum(['boots','helmet','off_hand','torsoe','weapon','ring','item_container']);

export type GameItemSlotType = `${z.infer<typeof GameItemSlotSchema>}`

export default GameItemSlotSchema;
